import { render, staticRenderFns } from "./firstSettingComponent.vue?vue&type=template&id=7b9cb276&"
import script from "./firstSettingComponent.vue?vue&type=script&lang=js&"
export * from "./firstSettingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports